export const CREATE_TAG_BATCH = `
  mutation CreateTagBatch($input: CreateTagBatchInput!) {
    createTagBatch(input: $input) {
      id
    }
  }
`;